export default __webpack_public_path__ + "text-extract19c99b.png";